import NewBookingForm from './NewBookingForm'

export default NewBookingForm
